// extracted by mini-css-extract-plugin
export default {"rating":"nG-z","numberOfStars":"oG-z","count":"pG-z","barGraphSpacing":"qG-z","barGraph":"rG-z"};